// TODO: 这个 request 看能不能封装成 axios 的一样的 API 和 效果（支持拦截等），这样使用体验会更好。
// 如果需要参考，我之前有写过一份。
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { joinParams, parseSearch } from './utils';
import { sendMessage } from './index';
// TODO: 这里的 as 没有必要，反而会减弱代码的理解程度(因为库本身也有 isAndroid 和 isIOS，虽然已废弃)。
// 可直接使用 isAndroidNative 和 isIOSNative
// import { isAndroidNative as isAndroid, isIOSNative as isIOS } from './platform';
import { isAndroidNative, isIOSNative } from './platform';
// 支持手雷统一的request云盘请求
const timeout = 1000 * 10;
export function request(url, params = {}, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const method = options.method || 'GET';
        if (method === 'GET') {
            url = joinParams(url, params);
        }
        if (isAndroidNative) {
            const res = yield sendMessage({
                platform: 'android',
                name: 'xlAjax',
                params: {
                    url,
                    method,
                    body: method === 'GET' ? undefined : params,
                },
            }, { callbackTimeout: timeout });
            if (res) {
                if (res.ret === 0) {
                    try {
                        const data = JSON.parse(res.body);
                        return [null, data];
                    }
                    catch (err) {
                        return [null, res.body];
                    }
                }
                else {
                    return [res, null];
                }
            }
            else {
                return [{ error_description: 'unknown' }, null];
            }
        }
        if (isIOSNative) {
            const parseURL = new URL(url);
            const iosRequestParams = {
                method,
                host: parseURL.origin,
                path: parseURL.pathname,
            };
            if (params && Object.keys(params).length > 0) {
                iosRequestParams.params = params;
            }
            if (method !== 'GET') {
                // json 参数请求必须传 1
                iosRequestParams.jsonRequest = 1;
                if (method === 'DELETE') {
                    iosRequestParams.jsonRequest = 0;
                    iosRequestParams.params = parseSearch(parseURL.search);
                }
            }
            if (options.headers) {
                iosRequestParams.headers = options.headers;
            }
            const [err, res] = yield sendMessage({ platform: 'ios', name: 'xlAjax', params: iosRequestParams }, { callbackTimeout: timeout });
            if (err === null && res && res.result === 0) {
                try {
                    const data = JSON.parse(res.data);
                    if (data.error) {
                        return [data, null];
                    }
                    return [null, data];
                }
                catch (err) {
                    return [null, res.data];
                }
            }
        }
    });
}
//# sourceMappingURL=data:application/json;base64,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